// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';
import moment from 'moment';

import ordersService from './service';
import * as basketActions from '../../../../../../basket/store/actions';
import * as ordersActions from './actions';
import * as types from './actionTypes';
import history from '../../../../../../../services/history';

const TOKEN_ERROR = 'Not Authorized.';

function* ordersSaga(payload) {
  yield put(ordersActions.startLoading());
  const res = yield call(ordersService, payload.data);
  yield put(ordersActions.stopLoading());
  if (res.ok && res.body) {
    const orders = res.body;
    if (orders.length > 1) {
      orders.sort((a, b) => moment(b.SubmittedOn).valueOf() - moment(a.SubmittedOn).valueOf());
    }
    yield put(ordersActions.ordersRequestSuccess(orders));
  } else if (res.body.Reason === TOKEN_ERROR) {
    localStorage.removeItem('loggedID');
    localStorage.removeItem('CartID');
    localStorage.removeItem('token');
    localStorage.removeItem('TradeCustomer');
    localStorage.removeItem('PaymentTypeForTradeCustomer');
    localStorage.removeItem('total');
    localStorage.removeItem('isBookshop');
    yield put(basketActions.basketReset());
    history.push('/');
  } else {
    yield put(ordersActions.ordersRequestFailed('An error has occurred.'));
  }
}

const ordersSagas = [
  takeEvery(types.ORDERS_REQUEST, ordersSaga),
];

export default ordersSagas;
